self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        globalAPI: false,
        getWorkerUrl: function (moduleId, label) {
          var pathPrefix = "/dist/";
          var result = (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
          if (/^((http:)|(https:)|(file:)|(\/\/))/.test(result)) {
            var currentUrl = String(window.location);
            var currentOrigin = currentUrl.substr(0, currentUrl.length - window.location.hash.length - window.location.search.length - window.location.pathname.length);
            if (result.substring(0, currentOrigin.length) !== currentOrigin) {
              if(/^(\/\/)/.test(result)) {
                result = window.location.protocol + result
              }
              var js = '/*' + label + '*/importScripts("' + result + '");';
              var blob = new Blob([js], { type: 'application/javascript' });
              return URL.createObjectURL(blob);
            }
          }
          return result;
        }
      };
    })({
  "editorWorkerService": "monaco-editor.0.50.0.afbd84bf87ff32f64c63d43e1a5dde9a.contentHashV1.worker.js",
  "json": "monaco-json.0.50.0.8435fc3e2402e85ba75e03f7a026c79d.contentHashV1.worker.js",
  "css": "monaco-css.0.50.0.015ecfa1e26bd849534c8972836535d8.contentHashV1.worker.js",
  "yaml": "monaco-yaml.0.50.0.73b3fc185caf8be79015220c720a6ebc.contentHashV1.worker.js",
  "less": "monaco-css.0.50.0.015ecfa1e26bd849534c8972836535d8.contentHashV1.worker.js",
  "scss": "monaco-css.0.50.0.015ecfa1e26bd849534c8972836535d8.contentHashV1.worker.js"
});
import "./contrib/anchorSelect/browser/anchorSelect.js";
import "./contrib/bracketMatching/browser/bracketMatching.js";
import "./browser/coreCommands.js";
import "./contrib/caretOperations/browser/caretOperations.js";
import "./contrib/caretOperations/browser/transpose.js";
import "./contrib/clipboard/browser/clipboard.js";
import "./contrib/codeAction/browser/codeActionContributions.js";
import "./browser/widget/codeEditor/codeEditorWidget.js";
import "./contrib/codelens/browser/codelensController.js";
import "./contrib/colorPicker/browser/colorContributions.js";
import "./contrib/colorPicker/browser/standaloneColorPickerActions.js";
import "./contrib/comment/browser/comment.js";
import "./contrib/contextmenu/browser/contextmenu.js";
import "./contrib/cursorUndo/browser/cursorUndo.js";
import "./browser/widget/diffEditor/diffEditor.contribution.js";
import "./contrib/diffEditorBreadcrumbs/browser/contribution.js";
import "./contrib/dnd/browser/dnd.js";
import "./contrib/documentSymbols/browser/documentSymbols.js";
import "./contrib/dropOrPasteInto/browser/copyPasteContribution.js";
import "./contrib/dropOrPasteInto/browser/dropIntoEditorContribution.js";
import "./contrib/find/browser/findController.js";
import "./contrib/folding/browser/folding.js";
import "./contrib/fontZoom/browser/fontZoom.js";
import "./contrib/format/browser/formatActions.js";
import "./contrib/gotoError/browser/gotoError.js";
import "./standalone/browser/quickAccess/standaloneGotoLineQuickAccess.js";
import "./contrib/gotoSymbol/browser/goToCommands.js";
import "./contrib/gotoSymbol/browser/link/goToDefinitionAtPosition.js";
import "./contrib/hover/browser/hoverContribution.js";
import "./standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js";
import "./contrib/inPlaceReplace/browser/inPlaceReplace.js";
import "./contrib/indentation/browser/indentation.js";
import "./contrib/inlayHints/browser/inlayHintsContribution.js";
import "./contrib/inlineCompletions/browser/inlineCompletions.contribution.js";
import "./contrib/inlineEdit/browser/inlineEdit.contribution.js";
import "./contrib/inlineProgress/browser/inlineProgress.js";
import "./standalone/browser/inspectTokens/inspectTokens.js";
import "./contrib/lineSelection/browser/lineSelection.js";
import "./contrib/linesOperations/browser/linesOperations.js";
import "./contrib/linkedEditing/browser/linkedEditing.js";
import "./contrib/links/browser/links.js";
import "./contrib/longLinesHelper/browser/longLinesHelper.js";
import "./contrib/multicursor/browser/multicursor.js";
import "./contrib/parameterHints/browser/parameterHints.js";
import "./standalone/browser/quickAccess/standaloneCommandsQuickAccess.js";
import "./standalone/browser/quickAccess/standaloneHelpQuickAccess.js";
import "./standalone/browser/quickAccess/standaloneGotoSymbolQuickAccess.js";
import "./contrib/readOnlyMessage/browser/contribution.js";
import "./standalone/browser/referenceSearch/standaloneReferenceSearch.js";
import "./contrib/rename/browser/rename.js";
import "./contrib/sectionHeaders/browser/sectionHeaders.js";
import "./contrib/semanticTokens/browser/documentSemanticTokens.js";
import "./contrib/semanticTokens/browser/viewportSemanticTokens.js";
import "./contrib/smartSelect/browser/smartSelect.js";
import "./contrib/snippet/browser/snippetController2.js";
import "./contrib/stickyScroll/browser/stickyScrollContribution.js";
import "./contrib/suggest/browser/suggestController.js";
import "./contrib/suggest/browser/suggestInlineCompletions.js";
import "./standalone/browser/toggleHighContrast/toggleHighContrast.js";
import "./contrib/toggleTabFocusMode/browser/toggleTabFocusMode.js";
import "./contrib/tokenization/browser/tokenization.js";
import "./contrib/unicodeHighlighter/browser/unicodeHighlighter.js";
import "./contrib/unusualLineTerminators/browser/unusualLineTerminators.js";
import "./contrib/wordHighlighter/browser/wordHighlighter.js";
import "./contrib/wordOperations/browser/wordOperations.js";
import "./contrib/wordPartOperations/browser/wordPartOperations.js";

import * as monaco from "!!../../../../../../@rsdoctor+core@1.6.0_@emnapi+core@1.11.1_@emnapi+runtime@1.11.3_@rsbuild+core@2.1.4_cor_6a0f44aa7b47270e9b5f374cf2fd6154/node_modules/@rsdoctor/core/dist/inner-plugins/loaders/proxy.cjs??ruleSet[1].rules[1].use[0]!./editor.api.js";
export * from "!!../../../../../../@rsdoctor+core@1.6.0_@emnapi+core@1.11.1_@emnapi+runtime@1.11.3_@rsbuild+core@2.1.4_cor_6a0f44aa7b47270e9b5f374cf2fd6154/node_modules/@rsdoctor/core/dist/inner-plugins/loaders/proxy.cjs??ruleSet[1].rules[1].use[0]!./editor.api.js";
export default monaco;
		
import "../basic-languages/python/python.contribution.js";
import "../basic-languages/r/r.contribution.js";
import "../basic-languages/markdown/markdown.contribution.js";
import "../basic-languages/yaml/yaml.contribution.js";
import "../basic-languages/sql/sql.contribution.js";
import "../basic-languages/redshift/redshift.contribution.js";
import "../basic-languages/pgsql/pgsql.contribution.js";
import "../basic-languages/mysql/mysql.contribution.js";
import "../language/json/monaco.contribution.js";
import "../basic-languages/css/css.contribution.js";
import "../language/css/monaco.contribution.js";
import "../basic-languages/javascript/javascript.contribution.js";
import "../../../../../../monaco-yaml@5.4.0_patch_hash=d2f2ef9ba4f7a01c36119a1ec7045c46c802f1cb0a7bf579a2de2452326af7ef_monaco-editor@0.50.0/node_modules/monaco-yaml/index.js";